import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../atoms/Button';
import Loader from '../atoms/Loader';
import Toast, { ToastType } from '../atoms/Toast';
import { getQueryParameter } from '../services/query-parameters';
import gql from '../services/gql';
import { FONT_PROXIMA_NOVA } from '../styles/fonts';

const useStyles = makeStyles(theme => ({
  optOut: {
    padding: theme.spacing(2, 4, 4),
    position: 'relative',
  },
  heading: {
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(20),
  },
  textContent: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: FONT_PROXIMA_NOVA,
  },
  bold: {
    fontWeight: 700,
  },
  actions: {
    marginTop: theme.spacing(3),
  },
  action: {
    width: '100px'
  },
}), { name: OptOut.name });

export default function OptOut () {
  const classes = useStyles();

  const [displaySuccessMessage, setDisplaySuccessMessage] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [toastVisible, setToastVisible] = useState<boolean>(false);
  const [toastMessage, setToastMessage] = useState<string>('');
  const [toastType, setToastType] = useState<ToastType>(ToastType.SUCCESS);

  const email = getQueryParameter('email');

  function onOptOut () {
    setLoading(true);

    gql(`
      mutation {
        optOutSMS(email: "${email}")
      }`
    )
      .then((data:any) => data.optOutSMS as boolean)
      .then((success:boolean) => {
        if (success) {
          setDisplaySuccessMessage(true);
        } else {
          showToast('Oops, something is wrong. Try again or contact our support team.', ToastType.ERROR);
        }
      })
      .catch((error) => {
        console.error(error);
        showToast('Oops, something is wrong. Try again or contact our support team.', ToastType.ERROR);
      })
      .finally(() => setLoading(false));
  }

  function showToast (message:string, toastType:ToastType = ToastType.SUCCESS) {
    setToastMessage(message)
    setToastVisible(true);
    setToastType(toastType);
  }

  return (
    <>
      <div className={classes.optOut}>
        <Loader inProgress={loading} />

        <div className={classes.heading}>
          {displaySuccessMessage
            ? 'Success! Opted out'
            : 'Opt out'
          }
        </div>

        {!displaySuccessMessage && (
          <>
            <p className={classes.textContent}>
              You will not receive text message updates from Tracking Football
            </p>

            <div className={classes.actions}>
              <Button
                className={classes.action}
                primary
                disabled={loading}
                onClick={onOptOut}
              >
                Opt out
              </Button>
            </div>
          </>
        )}

        {displaySuccessMessage && (
          <p className={classes.textContent}>
            You will not receive future text messages from Tracking Football.
          </p>
        )}
      </div>

      <Toast
        visible={toastVisible}
        type={toastType}
        onHide={() => setToastVisible(false)}
      >
        {toastMessage}
      </Toast>
    </>
  );
}
